<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 09:39:28
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-03-11 20:56:29
 * @Description: 营销内容-活码
 -->
<template>
  <div class="activity-code">
    <div class="top-tabs">
      <mk-tabs-biz
        v-model="activeName"
        class="el-tabs-mk-ui"
      >
        <mk-tab-pane
          label="企业活码"
          name="componyCode"
        >
        </mk-tab-pane>
        <mk-tab-pane
          name="saleQrcode"
          class="sale-qrcode"
        >
          <span slot="label">
            销售二维码
            <mk-popover
              trigger="hover"
              placement="right"
              popper-class="sale-table-tips"
              :content="saleTips"
            >
              <mk-iconfont
                slot="reference"
                icon-class="tishi-info"
              />
            </mk-popover>
          </span>
        </mk-tab-pane>
        <!--
        <mk-tab-pane
          v-for="(item, index) in tabs"
          :key="index"
          :label="item.label"
          :name="item.name"
        >
        </mk-tab-pane> -->
      </mk-tabs-biz>
    </div>
    <div class="main-state">
      <component :is="activeName"></component>
    </div>
  </div>
</template>

<script>
import componyCode from './compony-code-tab'
import saleQrcode from './sale-qrcode'
export default {
  name: 'ActivityCode',
  components: {
    componyCode,
    saleQrcode
  },
  data () {
    return {
      // 当前tab名
      activeName: 'componyCode',
      tabs: [
        {
          label: '企业活码',
          name: 'componyCode'
        },
        {
          label: '销售二维码',
          name: 'saleQrcode'
        }
      ],
      saleTips: '如何上传销售二维码：让销售在工作手机 -【我的】-【个人信息】中上传个人微信二维码图片'
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-code {
  display: flex;
  flex-direction: column;
  height: 100%;

  .top-tabs {
    .icon-mk-tishi-info {
      font-size: 14px;
      color: #1890ff;
      margin-right: 8px;
    }
  }

  .main-state {
    flex: 1;
    overflow: hidden;
  }

  // /deep/ .el-tabs__nav-scroll {
  //   .el-tabs__item {
  //     height: 60px;
  //     line-height: 60px;
  //     padding: 0 36px;
  //     font-weight: 500;
  //   }

  //   #tab-saleQrcode {
  //     position: relative;

  //     .iconfont {
  //       position: absolute;
  //       right: 0;
  //     }
  //   }

  //   .el-tabs__item.is-active {
  //     color: #009cff !important;
  //   }

  //   .el-tabs__active-bar {
  //     background: #009cff !important;
  //   }
  // }

  // /deep/ .el-tabs__active-bar {
  //   padding: 0 10px;
  //   margin-left: -10px;
  // }

  // /deep/ .el-tabs__nav-wrap {
  //   padding: 0 !important;
  // }
}
</style>
